import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["REPORT_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["REPORT_MODULE"],
  },
];

export default routes;
